<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <p>Ótimo! Agora preciso do seu <strong>número de celular</strong> e <strong>telefone comercial</strong>.</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="celular">Telefone celular</label>
            <input type="text" class="form-control form-control-lg" v-model="celular" v-mask="'phone'" placeholder="Celular" v-focus required>
          </div>
          <div class="form-group text-left">
            <label for="telefoneComercial" class="float-left">Telefone comercial</label>
            <input type="text" class="form-control form-control-lg" v-model="telefoneComercial" v-mask="'phone'" placeholder="Telefone Comercial">
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      celular: this.solicitacao.Celular,
      telefoneComercial: this.solicitacao.TelefoneComercial
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {Celular: this.celular, TelefoneComercial: this.telefoneComercial}
      this.$emit('on-submit', newData)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/ContactsStep.vue